import { NeutralBadge, StatusTag } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { Schemas } from "../../types";

export type CheckTypeStatus = Schemas["CredentialRequestStatus"];
interface Props {
  status?: Schemas["CredentialRequestStatus"];
  isLoading?: boolean;
}

export function CredentialRequestTypeBadge(props: Props) {
  const { status, isLoading } = props;

  const { t } = useTranslation();

  switch (status) {
    case "CREDENTIALS_AVAILABLE":
      return (
        <StatusTag
          leftIcon="inventory"
          fill="background-accent-blue-weak"
          color="text-accent-blue-strong"
          statusInfoIcon={false}
        >
          {t("Shared")}
        </StatusTag>
      );
    case "WITHDRAWN":
      return (
        <StatusTag
          leftIcon="block"
          fill="background-accent-neutral-weak"
          color="text-base"
          statusInfoIcon={false}
        >
          {t("Withdrawn")}
        </StatusTag>
      );
    case "WITHDRAWAL_REQUESTED":
      return (
        <StatusTag
          leftIcon="block"
          fill="background-accent-neutral-weak"
          color="text-base"
          statusInfoIcon={false}
        >
          {t("Withdrawal requested")}
        </StatusTag>
      );
    default:
      return (
        <NeutralBadge type="subtle" isLoading={isLoading}>
          {t("Required")}
        </NeutralBadge>
      );
  }
}
